import React, { useState, useEffect, useMemo, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Axios from "axios";
import { Container, Row, Col, Form, Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  addCategoryToDb,
  clearaddCategory,
} from "../redux/slices/Master/Category/addCategorySlice";
import { getCategoryFeatureFromDb } from "../redux/slices/getcategoryfeactureSice";
import {
  clearEditcategoryData,
  clearEditcategoryState,
  editcategoryUpdateToDb,
} from "../redux/slices/Master/Category/editCategorySlice";
import { setShowMessage } from "../redux/slices/notificationSlice";
import { useLocation, useNavigate } from "react-router-dom";
import translations from "../assets/locals/translations";
import Department from "./singleComponents/villageCom/Department";

export default function AddCategory({ workFor }) {
  const currentLanguage = useSelector((state) => state.language.language);
  const t = translations[currentLanguage] || translations['en'];
  const [dept, setDept] = useState([]);
  const [featuresList, setFeaturesList] = useState([]);
  const [checkField, setCheckField] = useState([]);
  const [fieldData, setFieldData] = useState([]);
  // const [checkFieldItem, setCheckFieldItem] = useState(true);
  const [checkFieldItem, setCheckFieldItem] = useState([]);
  const [treeTructureAlldataList, setTreeTructureAlldataList] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [categoryData, setCategoryData] = useState({
    category_name: "",
    category_description: "",
    department: "",
    chehkedFeature: [],
  });
  const [checkedItems, setCheckedItems] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const addCategory = useSelector((state) => state.addCategory.addCategory);
  const { editcategorySliceState } = useSelector(
    (state) => state.editCategoryDataState
  );
  const editcategoryData = useSelector(
    (state) => state.editCategoryDataState.editcategoryData
  );
  const featuresState = useSelector(
    (state) => state.categoryfeaturesListState.featuresState
  );

  function onChangeHandle(data, id) {
    const checked = data.target.checked;
    const disabled = data.target.disabled;

    // Update the featuresList
    const updatedFeaturesList = featuresList.map((item) => {
      if (item.id === id) {
        return { ...item, isChecked: checked, disabled: disabled };
      }
      return item;
    });

    setFeaturesList(updatedFeaturesList);

    // Rest of your code (if needed)
    let tempAr = [];
    updatedFeaturesList.forEach((item) => {
      if (item.isChecked) {
        tempAr.push(item.id);
      }
    });
    console.log(tempAr, "tempAr");

    setCategoryData((featureData) => ({
      ...featureData,
      chehkedFeature: tempAr,
    }));
  }

  const handleHeaderCheckboxClick = () => {
    const toggleAllChecked = !selectAll;

    let updatedFeaturesList;
    if (toggleAllChecked) {
      updatedFeaturesList = featuresList.map((item) => ({
        ...item,
        isChecked: true,
      }));
    } else {
      const defaultChecked = featuresList.filter((item) =>
        checkFieldItem.includes(item.id)
      );

      updatedFeaturesList = featuresList.map((item) => ({
        ...item,
        isChecked: defaultChecked.some(
          (defaultItem) => defaultItem.id === item.id
        ),
      }));
    }

    setFeaturesList(updatedFeaturesList);

    const checkedIds = toggleAllChecked
      ? updatedFeaturesList.map((item) => item.id)
      : updatedFeaturesList
        .filter((item) => item.isChecked)
        .map((item) => item.id);

    setCategoryData((featureData) => ({
      ...featureData,
      chehkedFeature: checkedIds,
    }));

    setSelectAll(toggleAllChecked);
  };

  // useEffect(() => {
  //   if (featuresState.isSuccess) {
  //     if (featuresState.data.isSuccess) {
  //       setFeaturesList(featuresState.data.result);
  //     }
  //   }
  // }, [featuresState]);

  useEffect(() => {
    if (featuresState.isSuccess) {
      if (featuresState.data.isSuccess) {
        console.log(
          featuresState,
          checkField,
          "featuresState@@@@@@@@@@@@@@@@@@@@@@in edit data get......."
        );
        const isMatchField = checkField.map((item) => item.id);
        const updatedFeaturesList = featuresState.data.result.map((item) => {
          if (checkFieldItem.includes(item.id)) {
            if (!isMatchField.includes(item.id)) {
              return { ...item, isChecked: true, disabled: false };
            } else {
              return { ...item, isChecked: true, disabled: true };
            }
          } else {
            return { ...item, isChecked: false, disabled: false };
          }
        });
        setFeaturesList(updatedFeaturesList);

        let tempAr = [];
        updatedFeaturesList.forEach((item) => {
          if (item.isChecked) {
            tempAr.push(item.id);
          }
        });
        console.log(tempAr, "tempAr");
        console.log(
          updatedFeaturesList,
          "updatedFeaturesListqqqqqqqqqqqqqqqqqqqq"
        );
        console.log(
          treeTructureAlldataList,
          "treeTructureAlldataList@@@@@@@@@@@@@@@@@@@@@@@@@"
        );

        const updateIsCheckedRecursively = (category, updatedFeaturesList) => {
          // Function to update each child and its nested children
          const updateChildren = (children) => {
            return children.map((child) => {
              const correspondingItem = updatedFeaturesList.find(
                (item) => item.id === child.id
              );
              // Recursively update nested children if they exist
              const updatedNestedChildren = child.children
                ? updateChildren(child.children)
                : [];

              return {
                ...child,
                isChecked: correspondingItem
                  ? correspondingItem.isChecked
                  : false,
                children: updatedNestedChildren, // Keep updating nested children
              };
            });
          };

          return {
            ...category,
            children: updateChildren(category.children),
          };
        };

        // Apply the recursive function to each category
        const updatedSecondArray = treeTructureAlldataList.map((category) =>
          updateIsCheckedRecursively(category, updatedFeaturesList)
        );
        console.log(
          updatedSecondArray,
          "updatedSecondArray$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$4"
        );
        setTreeTructureAlldataList(updatedSecondArray);

        const filteredArray = updatedFeaturesList
          .filter((item) => item.isChecked) // Filter only items with isChecked: true
          .map((item) => ({
            id: item.id,
            category_main_field_id: item.category_main_field_id,
            resource_id: item.resource_id,
          }));
        setCheckedItems(filteredArray);
        console.log(
          filteredArray,
          "..................................................................................."
        );
        setCategoryData((featureData) => ({
          ...featureData,
          chehkedFeature: filteredArray,
        }));
      }
    }
  }, [featuresState, checkFieldItem]);

  useEffect(() => {
    dispatch(getCategoryFeatureFromDb());
  }, []);

  useEffect(() => {
    if (editcategorySliceState.isSuccess) {
      if (editcategorySliceState.message.result === "success") {
        dispatch(setShowMessage("Data is Updated"));
        dispatch(clearEditcategoryState());
        navigate("/administration/configuration/category");
      } else {
        dispatch(setShowMessage("Something is wrong!"));
      }
    }
  }, [editcategorySliceState]);

  useEffect(() => {
    if (workFor === "forEdit") {
      if (editcategoryData.data === null) {
        setTimeout(() => {
          navigate("/administration/configuration/category");
          dispatch(setShowMessage("Please select a category"));
        }, 1000);
      } else {
        setCategoryData({
          category_name: editcategoryData.data.category_name,
          category_description: editcategoryData.data.category_description,
          department: editcategoryData.data.department,
          chehkedFeature: checkField,
        });
      }
    }
    return () => {
      if (workFor === "forEdit") {
        dispatch(clearEditcategoryData());
      }
    };
  }, [workFor, editcategoryData]);

  // async function getcategoryid(id) {
  //   const url = `${process.env.REACT_APP_NODE_URL}/api/master/get-categorybyid/${id}`;
  //   const config = {
  //     headers: {
  //       token: localStorage.getItem("rbacToken"),
  //     },
  //   };
  //   try {
  //     const response = await Axios.get(url, config);
  //     if (response.data?.isSuccess) {
  //       console.log(response.data.result, "editData");
  //       setCategoryData(response.data.result);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // }
  const getCategoryField = async (categoryId) => {
    console.log(categoryId, "categoryIs");
    if (categoryId) {
      const suburl = `${process.env.REACT_APP_NODE_URL}/api/master/get-category-fields/${categoryId}`;
      console.log(suburl, "suburl");
      const config = {
        headers: {
          token: localStorage.getItem("rbacToken"),
        },
      };
      try {
        const response = await Axios.get(suburl, config);
        if (response.data?.isSuccess) {
          console.log(response.data.result, "selectedFrild");
          setFieldData(response.data.result);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    if (addCategory && addCategory.isSuccess) {
      if (addCategory.isSuccess === true) {
        dispatch(setShowMessage("Category is created"));
        dispatch(clearaddCategory());
        navigate("/administration/configuration/category");
        clearaddCategory();
      } else {
        dispatch(setShowMessage("Something is wrong"));
      }
    }
  }, [addCategory]);
  useEffect(() => {
    if (workFor === "forEdit" && editcategoryData && editcategoryData.data) {
      const id = editcategoryData.data.id;
      getCategoryField(id);
    }
  }, []);

  async function getDeptList() {
    const url = `${process.env.REACT_APP_NODE_URL}/api/master/get-department-list`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await Axios.get(url, config).then((response) => {
      if (response.data.isSuccess) {
        const data = response.data.result;
        setDept(data);
      }
    });
  }
  function buildTree(data) {
    // Step 1: Group nodes by `category_main_field_id`
    const groupedByCategory = data.reduce((acc, el) => {
      const categoryId = el.category_main_field_id;
      if (!acc[categoryId]) {
        acc[categoryId] = [];
      }
      acc[categoryId].push(el);
      return acc;
    }, {});

    // Step 2: Create tree structure within each category
    const createTree = (nodes) => {
      const idMapping = nodes.reduce((acc, el, i) => {
        acc[el.id] = i;
        return acc;
      }, {});

      let root = [];

      nodes.forEach((el) => {
        if (el.resource_id === null) {
          root.push(el);
        } else {
          const parentEl = nodes[idMapping[el.resource_id]];

          // Check if parentEl exists
          if (parentEl) {
            // Initialize children array if it doesn't exist
            if (!parentEl.children) {
              parentEl.children = [];
            }

            // Push the current element as a child of the parent
            parentEl.children.push(el);
          } else {
            console.warn(
              `Parent with id ${el.resource_id} not found for element`,
              el
            );
          }
        }
      });

      return root;
    };

    // Step 3: Build the final tree with categories as root nodes
    const finalTree = Object.keys(groupedByCategory).map((categoryId) => {
      return {
        category_main_field_id: categoryId,
        children: createTree(groupedByCategory[categoryId]),
      };
    });

    return finalTree;
  }

  const handleCheckboxChange = (node, isChecked) => {
    setCheckedItems((prevCheckedItems) => {
      if (isChecked) {
        return [
          ...prevCheckedItems,
          {
            id: node.id,
            category_main_field_id: node.category_main_field_id,
            resource_id: node.resource_id,
          },
        ];
      } else {
        return prevCheckedItems.filter((item) => item.id !== node.id);
      }
    });

    // Recursive function to update isChecked property
    const updateChildrenRecursively = (children) => {
      return children.map((child) => {
        // If the child's ID matches the node's ID, update its isChecked
        if (child.id === node.id) {
          return {
            ...child,
            isChecked: isChecked,
          };
        }
        // If there are nested children, recurse into them
        if (child.children) {
          return {
            ...child,
            children: updateChildrenRecursively(child.children), // Recursive update
          };
        }
        return child; // Return unchanged child if no match or children
      });
    };

    // Update the main array's isChecked property recursively
    setTreeTructureAlldataList((prevMainArray) =>
      prevMainArray.map((category) => {
        return {
          ...category,
          children: updateChildrenRecursively(category.children), // Apply recursive update to children
        };
      })
    );
  };

  useEffect(() => {
    setCategoryData((featureData) => ({
      ...featureData,
      chehkedFeature: checkedItems,
    }));
  }, [checkedItems]);

  const handleSubmit = () => {
    console.log("Checked Items:", checkedItems); // Log the checked items
    console.log("new category data.......:", categoryData); // Log the checked items
    if (workFor === "forEdit") {
      categoryData["id"] = editcategoryData.data.id;
      console.log(categoryData, "editData@@@@@@@@@@@@@@@");
      dispatch(editcategoryUpdateToDb(categoryData));
    } else {
      dispatch(addCategoryToDb(categoryData));
    }
  };

  const getAllListcategoryField = () => {
    const url = `${process.env.REACT_APP_NODE_URL}/api/get-all-field-list`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    Axios.get(url, config).then((response) => {
      if (response.data) {
        if (response.data.isSuccess) {
          // console.log(response.data.result, "all record of fields......................")
          if (response.data.result.length > 0) {
            const treeData = buildTree(response.data.result);
            console.log(treeData, "------>");
            setTreeTructureAlldataList(treeData);
            // console.log(treeData, "treeeeeeeeeeeeeee of all records of fields.....................")
          }
        }
      }
    });
  };
  useEffect(() => {
    getDeptList();
    getAllListcategoryField();
  }, []);
  const onSelectedState = (value) => {
    setCategoryData((categoryData) => ({ ...categoryData, department: value }));
  };

  const onChangeHandler = (e) => {
    const { name, value } = e.target;

    setCategoryData((categoryData) => ({
      ...categoryData,
      [name]: value,
    }));
  };
  useEffect(() => {
    if (workFor === "forEdit") {
      if (editcategoryData.data && editcategoryData.data.length > 0) {
        setCategoryData({
          category_name: editcategoryData.data.category_name,
          category_description: editcategoryData.data.category_description,
          department: editcategoryData.data.department,
          chehkedFeature: checkField,
        });
      }
    }
  }, [workFor]);

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (workFor === "forEdit") {
  //     categoryData["id"] = editcategoryData.data.id;
  //     console.log(categoryData, "editData");
  //     dispatch(editcategoryUpdateToDb(categoryData));
  //   } else {
  //     console.log(categoryData, "forAdd");
  //     dispatch(addCategoryToDb(categoryData));
  //   }
  // };

  const getselectedData = () => {
    const newurl = `${process.env.REACT_APP_NODE_URL}/api/master/get-selected-category-field`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    Axios.get(newurl, config).then((response) => {
      if (response) {
        if (response.data.isSuccess) {
          console.log(
            response.data.result,
            "checkedFielddddddddddddddddddddddddddddddddddd"
          );
          setCheckField(response.data.result);
        }
      }
    });
  };

  useEffect(() => {
    getselectedData();
  }, []);

  useEffect(() => {
    if (checkField && fieldData) {
      const selectedIds = [
        ...checkField.map((item) => item.id),
        ...fieldData.map((item) => item.field_id),
      ];
      setCheckFieldItem((prevCheckFieldItem) => [
        ...prevCheckFieldItem,
        ...selectedIds,
      ]);
    }
  }, [checkField, fieldData]);

  function handlCancel() {
    navigate("/administration/configuration/category");
    console.log(categoryData, "categoryData");
  }
  const redirectModal = () => {
    navigate(-1);
  };

  const TreeNode = ({
    node,
    handleCheckboxChange,
    isChecked,
    parentChecked,
  }) => {
    const inputId = `feature-${node.id}`;

    return (
      <Form.Group className="mb-1">
        <Form.Check
          type="checkbox"
          id={inputId}
          name={inputId}
          label={node.name}
          checked={node.isChecked}
          disabled={!parentChecked}
          onMouseDown={(e) => e.preventDefault()}
          onChange={(e) => handleCheckboxChange(node, e.target.checked)}
        />
      </Form.Group>
    );
  };

  const TreeView = ({ treeData, onCheckboxChange, checkedItems = [] }) => {
    const isChecked = (node) => {
      return checkedItems.some((item) => item.id === node.id);
    };

    return (
      <>
        {treeData.map((category) => (
          <div
            key={category.category_main_field_id}
            className="mb-2 p-3 border rounded bg-white rounded shadow"
          >
            <h5 className="fw-bold small mb-2">
              {category.children[0].main_field_name}
            </h5>
            <Row>
              {category.children.map((node) => (
                <Col xs={12} sm={6} md={4} key={node.id} className="mb-1">
                  <TreeNode
                    node={node}
                    handleCheckboxChange={onCheckboxChange}
                    isChecked={isChecked(node)}
                    parentChecked={true}
                  />
                </Col>
              ))}
            </Row>
          </div>
        ))}
      </>
    );
  };

  return (
    <div className="bg-white rounded p-3">
      <main>
        <div className="row m-0">
          <div className="col-6">
            <h4 className="fw-bold mb-1">
              {workFor === "forAdd" ? t.createcategory : t.editcategory}
            </h4>
            <p className="text-muted mb-0">{t.addcategory_description}</p>
          </div>
          <div className="col-6 d-flex align-items-end justify-content-end">
            <Button
              variant="btn btn-warning mx-1"
              style={{
                width: "70px",
                height: "35px",
                fontSize: "14px",
                borderRadius: "20px",
              }}
              onClick={() => {
                redirectModal();
              }}
            >
              {t.back}
            </Button>
          </div>
          <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
            <label className="myLabel" htmlFor="email">
              {t.categoryname} *
            </label>
            <input
              value={categoryData.category_name}
              className="form-control"
              autoComplete="false"
              onChange={(e) => {
                onChangeHandler(e);
              }}
              type="text"
              name="category_name"
            />
          </section>
        </div>
        <div className="row m-0">
          <Department
            className="myInput inputElement"
            onSelectedState={onSelectedState}
            DeptId={categoryData.department}
          />
        </div>
        <div className=" row m-0">
          <section className="d-flex mt-3 flex-column col-12">
            <label className="myLabel" htmlFor="email">
              {t.categorydescription} *
            </label>
            <textarea
              value={categoryData.category_description}
              rows="5"
              className="form-control"
              autoComplete="false"
              onChange={(e) => {
                onChangeHandler(e);
              }}
              addCategory
              type="text"
              name="category_description"
            />
          </section>
          <section className="my-2">
            <TreeView
              treeData={treeTructureAlldataList}
              onCheckboxChange={handleCheckboxChange}
              checkedItems={checkedItems}
            />
          </section>

          <Row>
            <Col xs={12} className="text-center text-lg-end">
              <Button
                variant="primary"
                className="px-5 mb-2 mb-lg-0"
                onClick={handleSubmit}
                type="button"
              >
                {workFor === "forAdd" ? t.createcategory : t.savecategory}
              </Button>

              <Button
                variant="outline-secondary"
                className="ms-lg-3 px-4"
                onClick={handlCancel}
              >
                {t.cancel}
              </Button>
            </Col>
          </Row>
        </div>
      </main>
    </div>
  );
}
